import { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const SettingsContext = createContext({});

export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    currency_symbol: '₹',
    currency_name: 'INR',
    date_format: 'DD/MM/YYYY',
    company_name: 'MOZI INNOVATORS LLP',
    company_address: '',
    company_phone: '',
    company_gstin: '',
    company_email: '',
    timezone: 'Asia/Kolkata',
  });

  useEffect(() => {
    api.get('/settings').then(r => setSettings(s => ({ ...s, ...r.data }))).catch(() => {});
  }, []);

  // Format currency
  const formatCurrency = (amount) => {
    const num = parseFloat(amount) || 0;
    const sym = settings.currency_symbol || '₹';
    return `${sym}${num.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
  };

  // Format date based on setting
  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    try {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return '—';
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      const yy = String(yyyy).slice(-2);
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      const mmm = months[d.getMonth()];

      switch (settings.date_format) {
        case 'DD/MM/YYYY': return `${dd}/${mm}/${yyyy}`;
        case 'MM/DD/YYYY': return `${mm}/${dd}/${yyyy}`;
        case 'YYYY-MM-DD': return `${yyyy}-${mm}-${dd}`;
        case 'DD-MM-YYYY': return `${dd}-${mm}-${yyyy}`;
        case 'DD MMM YYYY': return `${dd} ${mmm} ${yyyy}`;
        case 'DD/MM/YY': return `${dd}/${mm}/${yy}`;
        default: return `${dd}/${mm}/${yyyy}`;
      }
    } catch { return '—'; }
  };

  return (
    <SettingsContext.Provider value={{ settings, setSettings, formatCurrency, formatDate }}>
      {children}
    </SettingsContext.Provider>
  );
}
